const map = {
  TaobaoFlashTransfer: () => import('@/views/transferOrder/transferForm/Detail'),
  TaobaoFlashTransferOrderDetail: () => import('@/views/transferOrder/transferRequestForm/Detail')
}

export default map
